import React from "react";

import DURMessage from "./DURMessage";
import { TestClaimFormattedDURMessages, TestClaimFormattedDURMessage } from "@/types/appTypes/transmissions";

const ResponseDURMessagesSegment: React.FC<TestClaimFormattedDURMessages> = (props: TestClaimFormattedDURMessages) => {
  const { durMessages } = props;

  if (!durMessages || (durMessages && durMessages.length === 0)) {
    return null;
  }

  return (
    <div className="response-segment" data-testid="test__response-segment">
      <div className="segment-name" data-testid="test__segment-name">
        DUR Messages
      </div>
      <div>
        {durMessages.map((durMessage: TestClaimFormattedDURMessage, index) => (
          <div className="row" key={`dur-message-${index}`}>
            <div className="test-claim-message col-12">
              <DURMessage
                durFreeTextMessage={durMessage.durFreeTextMessage}
                durAdditionalText={durMessage.durAdditionalText}
                reasonForServiceCode={durMessage.reasonForServiceCode}
                clinicalSignificanceCode={durMessage.clinicalSignificanceCode}
                otherPharmacyIndicator={durMessage.otherPharmacyIndicator}
                previousDateOfFill={durMessage.previousDateOfFill}
                quantityOfPreviousFill={durMessage.quantityOfPreviousFill}
                databaseIndicator={durMessage.databaseIndicator}
                otherPrescriberIndicator={durMessage.otherPrescriberIndicator}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResponseDURMessagesSegment;
